var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "annual-data" }, [
    !_vm.isUserInLA
      ? _c("div", [
          _vm._v("\n        Annual data can only be viewed for LA users.\n    ")
        ])
      : _c("div", [
          _vm.retrieveAnnualDataError
            ? _c("div", [
                _vm._v(
                  "\n            " + _vm._s(_vm.retrieveErrorMsg) + "\n        "
                )
              ])
            : _c(
                "div",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: { type: "button", variant: "primary" },
                      on: { click: _vm.downloadAnnualData }
                    },
                    [
                      _vm._v(
                        "\n                Download Annual Data\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.detailFields, function(item, id) {
                    return _c(
                      "p",
                      { key: id, staticClass: "annual-data__description" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "annual-data__description annual-data__description--bold"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(item.title) +
                                ":\n                "
                            )
                          ]
                        ),
                        _vm._v(
                          "\n                " +
                            _vm._s(item.value) +
                            "\n            "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("b-table", {
                    staticClass: "mt-5 annual-data-table",
                    attrs: {
                      "sticky-header": "600px",
                      striped: true,
                      bordered: false,
                      responsive: "md",
                      items: _vm.annualDataPersonRecords,
                      fields: _vm.annualDataTableFields,
                      "sort-compare": _vm.sortCompare,
                      "per-page": _vm.rowsPerPage,
                      "current-page": _vm.currentPage
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "annual-data__footer" },
                    [
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.annualDataPersonRecords.length,
                          "per-page": _vm.rowsPerPage,
                          "prev-text": "Prev",
                          "next-text": "Next",
                          "current-page": _vm.currentPage
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      }),
                      _vm._v(" "),
                      _vm.isAllowedToReview
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "button",
                                    variant: "secondary",
                                    size: "md"
                                  },
                                  on: { click: _vm.showCancelModal }
                                },
                                [_vm._v("Cancel")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "button",
                                    variant: "primary",
                                    size: "md"
                                  },
                                  on: { click: _vm.showConfirmModal }
                                },
                                [_vm._v("Confirm")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      ref: "cancelModal",
                      staticClass: "tos-modal",
                      attrs: {
                        centered: "",
                        title: "Annual Data Not Confirmed",
                        size: "lg",
                        "ok-title": "No, return to Annual Data",
                        "cancel-title": "Yes, cancel",
                        "header-bg-variant": "success",
                        "header-text-variant": "light",
                        "hide-header-close": "",
                        "no-close-on-backdrop": ""
                      },
                      on: { cancel: _vm.handleCancel }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "You have not confirmed your organization's Annual Data. Are you sure you want to leave?"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      ref: "confirmModal",
                      staticClass: "tos-modal",
                      attrs: {
                        centered: "",
                        title: "Confirm Annual Data",
                        size: "lg",
                        "cancel-title": "No, return to Annual Data",
                        "ok-title": "Yes, confirm",
                        "header-bg-variant": "success",
                        "header-text-variant": "light",
                        "hide-header-close": "",
                        "no-close-on-backdrop": ""
                      },
                      on: { ok: _vm.handleConfirm }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "\n                    Are you ready to confirm your organization's Annual Data?\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                    NOTE: Once you have confirmed your data, the "
                        ),
                        _c("b", [_vm._v("Review Annual Data")]),
                        _vm._v(
                          " button will disappear from your dashboard.\n                    If you need to update any confirmed data before the January 12 deadline, make the changes in Lighthouse\n                    and go to Data > Annual Report to reconfirm your organization's data.\n                "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      ref: "confirmedModal",
                      staticClass: "tos-modal",
                      attrs: {
                        centered: "",
                        title: "Annual Data Confirmed",
                        size: "lg",
                        "ok-only": "",
                        "header-bg-variant": "success",
                        "header-text-variant": "light",
                        "hide-header-close": "",
                        "no-close-on-backdrop": ""
                      },
                      on: { ok: _vm.handleConfirmed }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "\n                    Thank you for reviewing your organization's annual data.\n                    "
                        )
                      ]),
                      _vm.confirmAnnualDataError
                        ? _c("p", [
                            _vm._v(
                              "\n                        There was an error while sending a download of your confirmed data to your email address.\n                        Please click Download Annual Data to download your confirmed data.\n                    "
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n                        A download of your confirmed data has been sent to your email address.\n                    "
                            )
                          ]),
                      _vm._v(" "),
                      _c("p")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      ref: "confirmErrorModal",
                      staticClass: "tos-modal",
                      attrs: {
                        centered: "",
                        title: "Error",
                        size: "lg",
                        "ok-only": "",
                        "header-bg-variant": "danger",
                        "header-text-variant": "light",
                        "hide-header-close": "",
                        "no-close-on-backdrop": ""
                      },
                      on: { ok: _vm.hideConfirmErrorModal }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "\n                    An error occurred while confirming your data. Please try again.\n                "
                        )
                      ])
                    ]
                  )
                ],
                2
              )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-540acda9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-540acda9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/ReviewAnnualData.vue
// module id = 1938
// module chunks = 0